import React from "react";
import ReactDOM from "react-dom/client";
import EshopConfiguration from "../services/EshopConfiguration";
import ajaxClient from "../../../js/common/AjaxClient";
import SwitchCountryPopupModal, { SwitchCountryPopupTexts } from "./components/SwitchCountryPopupModal";

interface SwitchCountryPopupResponse {
    readonly popupTexts: SwitchCountryPopupTexts;
}

export default new class SwitchCountryPopupService {
    public init(eshopConfiguration: EshopConfiguration): void {
        if (eshopConfiguration.switchCountryPopup === null) {
            return;
        }

        void this.openSwitchCountryPopup(eshopConfiguration.switchCountryPopup);
    }

    private async openSwitchCountryPopup(country: string): Promise<void> {
        const response = await ajaxClient.get<SwitchCountryPopupResponse>(`/Customer/jsSwitchCountryPopup?country=${country}`);

        this.showSwitchCountryPopup(response.popupTexts);
    }

    private showSwitchCountryPopup(popupTexts: SwitchCountryPopupTexts): void {
        const popupContainer = document.createElement("div");
        const root = ReactDOM.createRoot(popupContainer);

        document.body.appendChild(popupContainer);

        root.render(<SwitchCountryPopupModal
            popupTexts={popupTexts}
            onAfterClose={(): void => {
                root.unmount();
                popupContainer.remove();
            }}
        />);
    }
}();
